import { VerificarPermissoes } from './../model/verificarPermissoes.model';
import { AccountService } from './account.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router, CanActivateChild, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private router: Router, private accountService: AccountService) {}
  
  canActivate(
    activated: ActivatedRouteSnapshot,
      state: RouterStateSnapshot): boolean  {
        if(this.accountService.temUsuarioLogado()){
            return true;
          } else {
              this.router.navigate(['login']);
              return false;
            }

          }
  // public canActivate(activated: ActivatedRouteSnapshot):Observable<boolean>{
    
  //   return this.checarRota(activated);
  // }
          
  public canActivateChild(childRoute: ActivatedRouteSnapshot): Observable<boolean> {
    return this.checarRota(childRoute);
  }

  protected checarRota(activated: ActivatedRouteSnapshot): Observable<boolean>{
    if(typeof activated.data['permissao'] !== 'undefined' && activated.data['permissao'].length){
      const permissaoRota = activated.data['permissao'];
      const permissoes = localStorage.getItem('permissoes');

      return new Observable<boolean>(subscriber => {
        if(!VerificarPermissoes.temPermissao(permissaoRota, permissoes)){
          subscriber.next(false);
          this.router.navigate(['/home']);
        } else {
          subscriber.next(true);
        }
      });
    }
    return new Observable<boolean>(subscriber => subscriber.next(true))
  }
  
}
